/**
 * Parser incremental de Server-Sent Events (IA-08).
 *
 * O `fetch` entrega o corpo em pedacos arbitrarios: um evento pode chegar partido no
 * meio da linha, do separador ou ate do `\r\n`. O parser guarda o resto entre chamadas
 * e so emite quando ve a linha em branco que fecha o evento. Segue o essencial da spec
 * do EventSource: `event:` e `data:` (varias linhas `data:` sao juntadas com `\n`),
 * linhas que comecam com `:` sao comentario, e o evento padrao e `message`.
 */
export interface SseMessage {
  event: string
  data: string
}

export interface SseParser {
  push(chunk: string): void
  flush(): void
}

const DEFAULT_EVENT = 'message'

export function createSseParser(onMessage: (msg: SseMessage) => void): SseParser {
  let buffer = ''
  let eventName = ''
  let dataLines: string[] = []

  const dispatch = () => {
    if (dataLines.length > 0) {
      onMessage({ event: eventName || DEFAULT_EVENT, data: dataLines.join('\n') })
    }
    eventName = ''
    dataLines = []
  }

  const processLine = (line: string) => {
    if (line === '') {
      dispatch()
      return
    }
    if (line.startsWith(':')) return

    const colon = line.indexOf(':')
    const field = colon === -1 ? line : line.slice(0, colon)
    let value = colon === -1 ? '' : line.slice(colon + 1)
    if (value.startsWith(' ')) value = value.slice(1)

    if (field === 'event') eventName = value
    else if (field === 'data') dataLines = [...dataLines, value]
  }

  const drainLines = () => {
    let newline = buffer.search(/\r\n|\r|\n/)
    while (newline !== -1) {
      // `\r` no fim do buffer pode ser metade de um `\r\n`: espera o proximo pedaco.
      if (buffer[newline] === '\r' && newline === buffer.length - 1) return
      const sepLength = buffer.startsWith('\r\n', newline) ? 2 : 1
      const line = buffer.slice(0, newline)
      buffer = buffer.slice(newline + sepLength)
      processLine(line)
      newline = buffer.search(/\r\n|\r|\n/)
    }
  }

  return {
    push(chunk: string) {
      buffer += chunk
      drainLines()
    },
    flush() {
      if (buffer.endsWith('\r')) buffer = buffer.slice(0, -1) + '\n'
      drainLines()
      if (buffer !== '') {
        processLine(buffer)
        buffer = ''
      }
      dispatch()
    },
  }
}
